import React, {Component} from 'react';
import FormatDate from '../FormatDate';
import SocialButtons from '../../../Shared/SocialButtons';
import {buildObitFlowersUrl} from '../../../../../../shared/utilities/urlHelpers';
import moment from 'moment';
import {connect} from 'react-redux';
import './css/CalendarEvent.styl';

export class CalendarEvent extends Component {
  static propTypes = {
    data: React.PropTypes.object,
  };

  static defaultProps = {
    funeralHome: {},
  };

  renderServices() {
    const {fullName, obituaryUrl, services} = this.props.data;

    const {affiliateId, funeralHome, isMobile} = this.props;
    const {location, flowerSettings} = funeralHome;

    const flowersUrlOptions = {
      personName: fullName,
      personId: this.props.data.obituaryId,
      affiliateId,
      cultureCode: location.country.cultureCode,
      flowerSettings,
      isMobile,
    };

    const flowersUrl = buildObitFlowersUrl(flowersUrlOptions);

    return services.map((service, index) => {
      const formattedServiceDate = moment
        .utc(service.serviceDate)
        .format('dddd, MMMM Do YYYY');
      const socialUrls = {obituaryUrl, flowersUrl};
      const socialService = {
        fullName,
        serviceDate: service.serviceDate,
        serviceType: service.serviceType,
      };

      return (
        <div key={index} className="calendar-event__container">
          <div className="calendar-event__title">
            <a href={`${obituaryUrl}`}>{fullName}</a>
          </div>
          <div className="calendar-event__event">
            <span>{service.serviceType}</span>
            <span className="calendar-event__service-date">
              {formattedServiceDate}
            </span>
          </div>
          <SocialButtons
            type="service"
            urls={socialUrls}
            details={socialService}
          />
          <div className="calendar-event__calendar-icon">
            <FormatDate dateString={service.serviceDate} />
          </div>
        </div>
      );
    });
  }

  render() {
    return (
      <div className="upcoming-services-collection">
        {this.renderServices()}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  affiliateId: state.affiliateStore.sourceId,
  funeralHome: state.funeralHomeStore,
  isMobile: state.mobileDetailsStore.any,
});

export default connect(mapStateToProps)(CalendarEvent);



// WEBPACK FOOTER //
// ./src/reactModules/pages/Profile/components/Tabs/UpcomingServices/CalendarEvent/index.js